import React, { useCallback, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardBody } from "reactstrap";
import classnames from "classnames";
import { TABS, TABS_BUTTONS } from "pages/operations/taskDetails/constants";
import GeneralInformationTab from "pages/operations/taskDetails/Tabs/GeneralInformationTab";
import { useJsApiLoader } from "@react-google-maps/api";
import { GOOGLE_MAPS_API_KEY, GOOGLE_MAPS_LIBRARIES } from "utils/constants";
import QuestionsTab from "pages/operations/taskDetails/Tabs/QuestionsTab";
import FeedbackFormTab from "pages/operations/taskDetails/Tabs/FeedbackFormTab";
import AssetsTab from "pages/operations/taskDetails/Tabs/AssetsTab";

const useStyles = makeStyles({
  root: {
    width: "100%",
    marginTop: 30,
    display: "flex",

    "@media (max-width: 576px)": {
      marginTop: 0,
      flexDirection: "column",
    },
  },
  container: {
    borderRadius: 30,
    width: "100%",
    padding: 30,

    "@media (max-width: 576px)": {
      padding: 0,
      marginBottom: 60,

      "&>.card-body": {
        padding: 10,
      },
    },
  },
  tabs: {
    display: "flex",
    padding: "30px 0",
    fontSize: 13,
    fontWeight: 600,
    flexDirection: "column",
    marginRight: -4,

    "@media (max-width: 576px)": {
      overflow: "auto",
      flexDirection: "row",
      padding: 0,
      marginBottom: 15,
    },
  },
  tab: {
    backgroundColor: "#E1E1E1",
    padding: 15,
    borderRadius: "10px 0 0 10px",
    marginBottom: 10,
    whiteSpace: "nowrap",

    "&:hover": {
      cursor: "pointer",
    },
    "@media (max-width: 576px)": {
      padding: 10,
      borderRadius: 30,
      marginRight: 5,
      marginBottom: 0,
    },
  },
  active: {
    backgroundColor: "#FFFFFF!important",
  },
  cardBody: {
    padding: 0,
  },
});

const DataTabs = ({ task, questionnaire, feedbacks }) => {
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(TABS.GENERAL_INFORMATION);
  const { isLoaded } = useJsApiLoader({
    id: "google-map",
    libraries: GOOGLE_MAPS_LIBRARIES,
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  });
  const onTabClick = useCallback(e => {
    const tab = e.target.dataset.tab;
    setActiveTab(tab);
  }, []);

  return (
    <div className={classes.root}>
      <div className={classes.tabs}>
        {TABS_BUTTONS.map(item => {
          if (item?.allowCategories && !item.allowCategories.includes(task.category)) return null;

          return (
            <div
              key={item.key}
              className={classnames(classes.tab, activeTab === item.key && classes.active)}
              data-tab={item.key}
              onClick={onTabClick}
            >
              {item?.allowCategories && item.allowCategories.includes(task.category)
                ? `${item?.showCategory ? task.category : ""} ${item.title}`
                : item.title}
            </div>
          );
        })}
      </div>
      <Card className={classes.container}>
        <CardBody className={classes.cardBody}>
          {activeTab === TABS.GENERAL_INFORMATION && task && <GeneralInformationTab task={task} isLoaded={isLoaded} />}
          {activeTab === TABS.ASSETS && task && <AssetsTab task={task} />}
          {activeTab === TABS.QUESTIONNAIRE && questionnaire && (
            <QuestionsTab taskSurvey={task.survey} leadQuestionnaire={questionnaire} />
          )}
          {activeTab === TABS.FEEDBACK_FORM && <FeedbackFormTab feedbacks={feedbacks} />}
        </CardBody>
      </Card>
    </div>
  );
};

export default DataTabs;
